import React, { useState, Fragment } from "react"
import Button from "react-bootstrap/lib/Button"
import BubbleModal from "../../../ui-components/BubbleModal"

import Stars from "../Stars"
import * as api from "../../../apis/Authenticated/Orders/index.js"

import style from "./index.module.sass"

// ----------------------------------------------------------------------------

const RATING_KEYS = [
  "punctuality",
  // "politeness",
  "food_temperature",
  "food_integrity",
  "other",
]

const ICONS = [
  "fa-clock",
  // "fa-laugh-wink",
  "fa-temperature-high",
  "fa-cheeseburger",
  "fa-comments",
]

const initialRatings = {
  [RATING_KEYS[0]]: undefined,
  [RATING_KEYS[1]]: undefined,
  [RATING_KEYS[2]]: undefined,
  [RATING_KEYS[3]]: undefined,
  // [RATING_KEYS[4]]: undefined,
}

function RatingModal(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { order, onHide = () => {}, userToken, ...otherProps } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  const [loading, setLoading] = useState(false)
  const [step, setStep] = useState(0)
  const [ratings, setRatings] = useState(initialRatings)

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function handleVote(vote) {
    setRatings({ ...ratings, [RATING_KEYS[step]]: vote })
  }

  function handleTextChange(e) {
    setRatings({ ...ratings, [RATING_KEYS[step]]: e.target.value })
  }

  async function handleNext() {
    // if there is no vote, do not proceed
    if (!!ratings[RATING_KEYS[step]] || step >= RATING_KEYS.length - 1) {
      if (step >= RATING_KEYS.length - 1) {
        setLoading(true)
        try {
          let res = await api.orderRating(order.id, ratings, userToken)
          if (res) {
            onHide("refresh")
          } else {
            setLoading(false)
          }
        } catch (err) {
          setLoading(false)
        }
      } else {
        setStep(step + 1)
      }
    }
  }

  function handleHide() {
    // TODO: improve state
    setStep(0)
    setRatings(initialRatings)
    onHide()
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  return (
    <BubbleModal {...otherProps} onHide={handleHide}>
      <div className={style.inner}>
        <h2 className={style.modalTitle}>
          {I18n.t(`pages.order_ratings.new.leave_feedback`)}
        </h2>
        {loading && <i className="fas fa-spinner fa-spin"></i>}
        {!loading && (
          <Fragment>
            <i className={`fal ${ICONS[step]} ${style.icon}`}></i>
            <p className={style.subtitle}>
              {step + 1}/{RATING_KEYS.length}
            </p>
            <h2 className={style.title}>
              {I18n.t(
                `pages.order_ratings.new.steps.${RATING_KEYS[step]}.title`
              )}
            </h2>
            <p className={style.subtitle}>
              {I18n.t(
                `pages.order_ratings.new.steps.${RATING_KEYS[step]}.description`
              )}
            </p>
            {step < RATING_KEYS.length - 1 && (
              <Stars
                className={style.stars}
                currentVote={ratings[RATING_KEYS[step]]}
                setCurrentVote={handleVote}
              />
            )}
            {step >= RATING_KEYS.length - 1 && (
              <textarea
                className={style.freeInput}
                onChange={handleTextChange}
              />
            )}

            {step < RATING_KEYS.length - 1 && (
              <div
                className={`${style.nextButton} ${
                  !!ratings[RATING_KEYS[step]] ? "" : style.disabled
                }`}
                onClick={handleNext}
              >
                <div className={style.nextInner}>
                  <i className="fas fa-chevron-right"></i>
                </div>
              </div>
            )}
            {step >= RATING_KEYS.length - 1 && (
              <Button bsStyle="primary" onClick={handleNext}>
                {I18n.t(
                  `pages.order_ratings.new.steps.${RATING_KEYS[step]}.send`
                )}
              </Button>
            )}
          </Fragment>
        )}
      </div>
    </BubbleModal>
  )
}

// ----------------------------------------------------------------------------

export default RatingModal
